export default {
  namespaced: true,
  state: {
    form: {},
  },
}
